import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import ErrorSpan from './ErrorSpan';

import {
  FormGroup,
  Label,
  Input,
  Button
} from 'reactstrap';

class UserForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      warning: false
    }
  }

  /**
   * Hide warning when losing focus.
   * @param handleBlur Formik blur event.
   * @param event      Input event.
   */
  onBlur(handleBlur, event) {
    this.setState({ warning: false });
    handleBlur(event);
  }

  /**
   * Detect caps lock being on when typing.
   * @param keyEvent On key down event.
   */
  onKeyUp = keyEvent => {
    if (keyEvent.getModifierState("CapsLock")) {
      this.setState({ warning: true });
    } else {
      this.setState({ warning: false });
    }
  };

  /**
   * Detect caps lock being on when typing.
   * @param keyEvent On key down event.
   */
  onKeyDown = keyEvent => {
    if (keyEvent.getModifierState("CapsLock")) {
      this.setState({ warning: true });
    } else {
      this.setState({ warning: false });
    }
  };

  render() {
    return (
      <Fragment>
        <h3>Update User Info</h3>
        <Formik
          validateOnBlur={false}
          initialValues={{
            first_name: this.props.user.first_name,
            last_name: this.props.user.last_name
          }}
          onSubmit={(values, {setSubmitting,resetForm,initialValues,setErrors,isTouched}) => {
            const resetThisForm = ()=>resetForm(initialValues);
            this.props.updateUser(values, setSubmitting, resetThisForm, setErrors, isTouched)
          }}
          render=
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue,
          }) => (
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label for="first_name">First name</Label>
              <Field
                type="text"
                name="first_name"
                render={ ({field}) => (
                <Input
                  {...field}
                  type="text"
                  required />
              )} />
              <ErrorMessage name="first_name" component={ErrorSpan} />
            </FormGroup>
            <FormGroup>
              <Label for="last_name">Last name</Label>
              <Field
                type="text"
                name="last_name"
                render={ ({field}) => (
                <Input
                  {...field}
                  type="text"
                  required />
              )} />
              <ErrorMessage name="last_name" component={ErrorSpan} />
            </FormGroup>
            <Button color="info" type="submit" disabled={isSubmitting}>
              Update
            </Button>
          </Form>
          )
        }
        />
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateUser: (values, setSubmitting, resetForm, setErrors, isTouched) => dispatch({ type: 'UPDATE_USER_REQUEST', payload: { values, setSubmitting, resetForm, setErrors, isTouched }})
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserForm);
